import React, { useState } from "react";
import { staffAPI } from "../../services/api";
import { handleApiError } from "../../utils/errorUtils";
import "./StartSessionButton.css";

const SESSION_START_OPTIONS = {
  infrared: {
    label: "Infrared Sauna Session",
    defaultDuration: 50,
    presets: [30, 50, 60],
  },
  redlight: {
    label: "Red Light Session",
    defaultDuration: 20,
    presets: [15, 20, 30],
  },
  massage_60: {
    label: "60 Minute Massage",
    defaultDuration: 60,
    presets: [60, 75, 90],
  },
  massage_90: {
    label: "90 Minute Massage",
    defaultDuration: 90,
    presets: [60, 90, 120],
  },
};

const StartSessionButton = ({ bookingId, sessionType, onSessionStarted }) => {
  const sessionOptions = SESSION_START_OPTIONS[sessionType] || {
    label: "Session",
    defaultDuration: 30,
    presets: [30, 60],
  };
  const [isStarting, setIsStarting] = useState(false);
  const [showDurationModal, setShowDurationModal] = useState(false);
  const [customDuration, setCustomDuration] = useState(
    sessionOptions.defaultDuration
  );

  const runStart = async (duration) => {
    try {
      setIsStarting(true);
      await staffAPI.startSession(bookingId, duration);
      setShowDurationModal(false);

      if (onSessionStarted) {
        onSessionStarted(bookingId);
      }
    } catch (err) {
      handleApiError(
        err,
        "StartSessionButton.handleStartSession",
        (message) => alert(message),
        "Error starting session"
      );
    } finally {
      setIsStarting(false);
    }
  };

  const handleStartNow = () => {
    runStart();
  };

  const handleCustomStartClick = () => {
    setShowDurationModal(true);
  };

  const handleStartSession = () => {
    runStart(customDuration);
  };

  const handleCancel = () => {
    setShowDurationModal(false);
  };

  return (
    <>
      <div className="start-session-actions">
        <button
          className="action-btn action-btn-start"
          onClick={handleStartNow}
          disabled={isStarting}
        >
          {isStarting ? "Starting..." : "Start Now"}
        </button>
        <button
          className="action-btn action-btn-secondary"
          onClick={handleCustomStartClick}
          disabled={isStarting}
        >
          Custom Start
        </button>
      </div>

      {showDurationModal && (
        <div className="duration-modal-overlay">
          <div className="duration-modal">
            <h3>Start Session</h3>
            <p>{sessionOptions.label}</p>

            <div className="duration-input">
              <label htmlFor="sessionDuration">
                Session Duration (minutes):
              </label>
              <input
                id="sessionDuration"
                type="number"
                min="1"
                max="120"
                value={customDuration}
                onChange={(e) => setCustomDuration(Number(e.target.value))}
              />
            </div>

            <div className="duration-presets">
              <button
                className="preset-btn"
                onClick={() => setCustomDuration(sessionOptions.defaultDuration)}
              >
                Default ({sessionOptions.defaultDuration} min)
              </button>
              {sessionOptions.presets
                .filter((duration) => duration !== sessionOptions.defaultDuration)
                .map((duration) => (
                  <button
                    key={duration}
                    className="preset-btn"
                    onClick={() => setCustomDuration(duration)}
                  >
                    {duration} min
                  </button>
                ))}
            </div>

            <div className="modal-actions">
              <button
                className="action-btn action-btn-secondary"
                onClick={handleCancel}
                disabled={isStarting}
              >
                Cancel
              </button>
              <button
                className="action-btn action-btn-success"
                onClick={handleStartSession}
                disabled={isStarting || customDuration < 1}
              >
                {isStarting ? "Starting..." : "Start Now"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StartSessionButton;
